// extracted by mini-css-extract-plugin
export default {"content":"read-more-less_content__aVW65"};